/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductOrderStatusSummary
 */
export interface ProductOrderStatusSummary {
    /**
     * 
     * @type {string}
     * @memberof ProductOrderStatusSummary
     */
    productId: string;
    /**
     * 
     * @type {string}
     * @memberof ProductOrderStatusSummary
     */
    productNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ProductOrderStatusSummary
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductOrderStatusSummary
     */
    productThumbnailUrl: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductOrderStatusSummary
     */
    productManufacturers: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductOrderStatusSummary
     */
    productThemes: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductOrderStatusSummary
     */
    productTypes: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProductOrderStatusSummary
     */
    requestedQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOrderStatusSummary
     */
    customerOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOrderStatusSummary
     */
    totalValueOfCustomerOrders: number;
    /**
     * 
     * @type {Date}
     * @memberof ProductOrderStatusSummary
     */
    lastRequestedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof ProductOrderStatusSummary
     */
    acceptedQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOrderStatusSummary
     */
    salesOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOrderStatusSummary
     */
    totalValueOfSalesOrders: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOrderStatusSummary
     */
    shippedQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOrderStatusSummary
     */
    processingQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOrderStatusSummary
     */
    outstandingQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOrderStatusSummary
     */
    claimCount: number;
}

/**
 * Check if a given object implements the ProductOrderStatusSummary interface.
 */
export function instanceOfProductOrderStatusSummary(value: object): value is ProductOrderStatusSummary {
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('productNumber' in value) || value['productNumber'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('productThumbnailUrl' in value) || value['productThumbnailUrl'] === undefined) return false;
    if (!('productManufacturers' in value) || value['productManufacturers'] === undefined) return false;
    if (!('productThemes' in value) || value['productThemes'] === undefined) return false;
    if (!('productTypes' in value) || value['productTypes'] === undefined) return false;
    if (!('requestedQuantity' in value) || value['requestedQuantity'] === undefined) return false;
    if (!('customerOrderCount' in value) || value['customerOrderCount'] === undefined) return false;
    if (!('totalValueOfCustomerOrders' in value) || value['totalValueOfCustomerOrders'] === undefined) return false;
    if (!('acceptedQuantity' in value) || value['acceptedQuantity'] === undefined) return false;
    if (!('salesOrderCount' in value) || value['salesOrderCount'] === undefined) return false;
    if (!('totalValueOfSalesOrders' in value) || value['totalValueOfSalesOrders'] === undefined) return false;
    if (!('shippedQuantity' in value) || value['shippedQuantity'] === undefined) return false;
    if (!('processingQuantity' in value) || value['processingQuantity'] === undefined) return false;
    if (!('outstandingQuantity' in value) || value['outstandingQuantity'] === undefined) return false;
    if (!('claimCount' in value) || value['claimCount'] === undefined) return false;
    return true;
}

export function ProductOrderStatusSummaryFromJSON(json: any): ProductOrderStatusSummary {
    return ProductOrderStatusSummaryFromJSONTyped(json, false);
}

export function ProductOrderStatusSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductOrderStatusSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'productId': json['productId'],
        'productNumber': json['productNumber'],
        'productName': json['productName'],
        'productThumbnailUrl': json['productThumbnailUrl'],
        'productManufacturers': json['productManufacturers'],
        'productThemes': json['productThemes'],
        'productTypes': json['productTypes'],
        'requestedQuantity': json['requestedQuantity'],
        'customerOrderCount': json['customerOrderCount'],
        'totalValueOfCustomerOrders': json['totalValueOfCustomerOrders'],
        'lastRequestedAt': json['lastRequestedAt'] == null ? undefined : (new Date(json['lastRequestedAt'])),
        'acceptedQuantity': json['acceptedQuantity'],
        'salesOrderCount': json['salesOrderCount'],
        'totalValueOfSalesOrders': json['totalValueOfSalesOrders'],
        'shippedQuantity': json['shippedQuantity'],
        'processingQuantity': json['processingQuantity'],
        'outstandingQuantity': json['outstandingQuantity'],
        'claimCount': json['claimCount'],
    };
}

export function ProductOrderStatusSummaryToJSON(json: any): ProductOrderStatusSummary {
    return ProductOrderStatusSummaryToJSONTyped(json, false);
}

export function ProductOrderStatusSummaryToJSONTyped(value?: ProductOrderStatusSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productId': value['productId'],
        'productNumber': value['productNumber'],
        'productName': value['productName'],
        'productThumbnailUrl': value['productThumbnailUrl'],
        'productManufacturers': value['productManufacturers'],
        'productThemes': value['productThemes'],
        'productTypes': value['productTypes'],
        'requestedQuantity': value['requestedQuantity'],
        'customerOrderCount': value['customerOrderCount'],
        'totalValueOfCustomerOrders': value['totalValueOfCustomerOrders'],
        'lastRequestedAt': value['lastRequestedAt'] == null ? value['lastRequestedAt'] : value['lastRequestedAt'].toISOString(),
        'acceptedQuantity': value['acceptedQuantity'],
        'salesOrderCount': value['salesOrderCount'],
        'totalValueOfSalesOrders': value['totalValueOfSalesOrders'],
        'shippedQuantity': value['shippedQuantity'],
        'processingQuantity': value['processingQuantity'],
        'outstandingQuantity': value['outstandingQuantity'],
        'claimCount': value['claimCount'],
    };
}

